export default "__VITE_ASSET__BU2qwSB3__"